import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home/home.vue"),
      meta:{tittle:'首页'},
      // props: (route) => ({ 
      //   icon_avatar: route.query.icon_avatar,
      //   username:route.query.username,
      //  }),
    children: [
      
      {
        path: "/iotcard",
        name: "iotcard",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/iotcard/iotcard.vue"),
          meta:{tittle:'物联网卡'},
      },
      {
        path: "/user",
        name: "user",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/user/user.vue"),
          meta:{tittle:'用户'},
      },
      {
        path: "/AdminUser",
        name: "AdminUser",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/user/AdminUser.vue"),
          meta:{tittle:'管理员与成员'},
      },

      {
        path: "/AdminUser2",
        name: "AdminUser2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/user/AdminUser2.vue"),
          meta:{tittle:'管理员与成员'},
      },

      
      {
        path: "/role",
        name: "role",
        props: true, // 接收参数
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/role/role.vue"),
          meta:{tittle:'角色'},
          
      },
      {
        path: "/database",
        name: "database",
        component: () =>
          import( /* webpackChunkName: "about" */ "../views/database/database.vue"),
          meta:{tittle:'数据库'},
          
      },
      {
        path: "/database2",
        name: "database2",
        component: () =>
          import( /* webpackChunkName: "about" */ "../views/database/database2.vue"),
          meta:{tittle:'管理员与设备'},
          
      },
      {
        path: "/databaseBySuperAdmin",
        name: "databaseBySuperAdmin",
        component: () =>
          import( /* webpackChunkName: "about" */ "../views/database/databaseBySuperAdmin.vue"),
          meta:{tittle:'设备导入(超级管理员)'},
          
      },
      
      {
        path: "/admin",
        name: "admin",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/admin/admin.vue"),
          meta:{tittle:'管理员'},
      },
      {
        path: "/WebSocketTest",
        name: "WebSocketTest",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/WebSocketTest/WebSocketTest.vue"),
          meta:{tittle:'WebSocketTest'},
      },
      {
        path: "/operationUIWebSocketTest",
        name: "operationUIWebSocketTest",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/WebSocketTest/operationUIWebSocketTest.vue"),
          meta:{tittle:'operationUIWebSocketTest'},
      },
      {
        path: "/admintest",
        name: "admintest",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/admin/admintest.vue"),
          meta:{tittle:'管理员测试'},
      },
      {
        path: "/admintest2",
        name: "admintest2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/admin/admintest2.vue"),
          meta:{tittle:'用户信息'},
      },
      {
        path: "/charts",
        name: "charts",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/charts/charts.vue"),
          meta:{tittle:'图表'},
      },
      {
        path: "/chartsByHeatingRecord",
        name: "chartsByHeatingRecord",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/charts/chartsByHeatingRecord.vue"),
          meta:{tittle:'设备加热时长记录'}, 

      },
      {
        path: "/charts2",
        name: "charts2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/charts/charts2.vue"),
          meta:{tittle:'设备历史数据记录'},
      },
      {
        path: "/charts3",
        name: "charts3",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/charts/charts3.vue"),
          meta:{tittle:'charts3'},
      },
      {
        path: "/charts4",
        name: "charts4",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/charts/charts4.vue"),
          meta:{tittle:'charts4'},
      },
      
      {
        path: "/chartjingxingneng",
        name: "chartjingxingneng",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/charts/chartjingxingneng.vue"),
          meta:{tittle:'京兴能设备历史数据记录'},
      },
      {
        path: "/test",
        name: "test",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/test.vue"),
          meta:{tittle:'测试'},
      },
      {
        path: "/test2",
        name: "test",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/test2.vue"),
          meta:{tittle:'测试2'},
      },
      {
        path: "/testPubAPI",
        name: "testPubAPI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testPubAPI.vue"),
          meta:{tittle:'操作界面'},
      },
      {
        path: "/testAI",
        name: "testAI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testAI.vue"),
          meta:{tittle:'AI'},
      },
      {
        path: "/testNextALiIOT",
        name: "testNextALiIOT",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testNextALiIOT.vue"),
          meta:{tittle:'testNextALiIOT'},
      },
      {
        path: "/testProfitSharing",
        name: "testProfitSharing",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testProfitSharing.vue"),
          meta:{tittle:'testProfitSharing'},
      },
      {
        path: "/testiplocation",
        name: "testiplocation",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testiplocation.vue"),
          meta:{tittle:'testiplocation'},
      },
      {
        path: "/NewProtocoloperationUI",
        name: "NewProtocoloperationUI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/operationUI/NewProtocoloperationUI.vue"),
          meta:{tittle:'新协议操作界面'},
      },
      {
        path: "/NewProtocoloperationUIBybatchoperations",
        name: "NewProtocoloperationUIBybatchoperations",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/operationUI/NewProtocoloperationUIBybatchoperations.vue"),
          meta:{tittle:'新协议批量操作界面'},
      },
      {
        path: "/NormalProtocolOperationUI",
        name: "NormalProtocolOperationUI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/operationUI/NormalProtocolOperationUI.vue"),
          meta:{tittle:'旧协议操作界面'},
      },
      {
        path: "/XJYLPerationUI",
        name: "XJYLPerationUI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/operationUI/XJYLPerationUI.vue"),
          meta:{tittle:'仙基医疗操作界面'},
      },
      {
        path: "/HPOperationUI.vue",
        name: "HPOperationUI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/operationUI/HPOperationUI.vue"),
          meta:{tittle:'汇普操作界面'},
      },
      {
        path: "/testPubAPI2",
        name: "testPubAPI2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testPubAPI2.vue"),
          meta:{tittle:'京兴能操作界面'},
      },
      {
        path: "/test6",
        name: "test6",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/test6.vue"),
          meta:{tittle:'test6'},
      },
      {
        path: "/test5",
        name: "test5",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/test5.vue"),
          meta:{tittle:'testest5t6'},
      },
      {
        path: "/testHP",
        name: "testHP",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testHP.vue"),
          meta:{tittle:'testHP'},
      },
      {
        path: "/testAliIOTMqttConnect",
        name: "testAliIOTMqttConnect",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/test/testAliIOTMqttConnect.vue"),
          meta:{tittle:'testAliIOTMqttConnect'},
      },

      {
        path: "/operationUI",
        name: "operationUI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/operationUI/operationUI.vue"),
          meta:{tittle:'操作界面'},
      },
      {
        path: "/JingXingNengOperationUI",
        name: "JingXingNengOperationUI",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/operationUI/JingXingNengOperationUI.vue"),
          meta:{tittle:'京兴能操作界面'},
      },

      {
        path: "/Alarm",
        name: "Alarm",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Alarm/Alarm.vue"),
          meta:{tittle:'故障报警'},
      },
      {
        path: "/InfoLog",
        name: "InfoLog",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/InfoLog/InfoLog.vue"),
          meta:{tittle:'用户操日志'},
      },
      {
        path: "/InfoLog2",
        name: "InfoLog2",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/InfoLog/InfoLog2.vue"),
          meta:{tittle:'用户操日志'},
      },
      
      {
        path: "/Oderdetail",
        name: "Oderdetail",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Oderdetail/Oderdetail.vue"),
          meta:{tittle:'商品订单'},
      },
      
    ],
  },
  {
    path: "/ValidCode",
    name: "ValidCode",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/ValidCode.vue"),
  },
  {
    path: "/",
    redirect: "/Login"
  },
  {
    path: "/Login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/NewLogin.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/register.vue"),
  },
  {
    path: "/password",
    name: "password",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/password/password.vue"),
  },
  {
    path: "/wxcode",
    name: "wxcode",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/test3.vue"),
      meta:{tittle:'获取微信公众号code'},
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // //to.name是登录路由的名字
  //   if (to.name!='/login') {
  //   //token思路就是登录成功之后保存起来，然后下面拿来用
  //     let token = sessionStorage.getItem("token")
  //   //判断token是否已经保存了
  //     if (token) {
  //     //成功跳转
  //       next()
  //     } else {
  //       Vue.prototype.$message({
  //         type: "error",
  //         message: "请先登录"
  //      });
  //       next('/')
  //     }
  //   } else {
  //   //不能把所有路由都拦截拦，要留个登陆路由
  //     next()
  //   }
  const userinfo = localStorage.getItem("userinfo");
  console.log("to.path:"+to.path)
  console.log("userinfo:"+userinfo)
  if(to.path == "/Login"){

    console.log(111);

    return next();

  }
  if(to.path == "/register"){

    console.log("/register");

    return next();

  }

  if(to.path == "/password"){

    console.log("/password");

    return next();

  }

  if(to.path != "/Login" && userinfo==null){

    console.log(2222);

     return next("/Login");

  }

  if(to.path != "/Login" && userinfo!=null){

    console.log(333);

     
    return next();

  }
  if(to.path != "/test3"){

    console.log("访问获取微信code:/test3");

     
    return next();

  }
  // if(userinfo==null)
  // {
  //   return next("/Login");
  // }


})

export default router;
